import DataMapper from './DataMapper'
import MrdChargesRM from '../responsemodel/MrdChargesRM'
import MrdCharges from "../../models/MrdCharges"
export default class MrdChargesDataMapper extends DataMapper<MrdChargesRM, MrdCharges> {
    map = (rm: MrdChargesRM) => { return  new MrdCharges(rm._id, rm.claim_number, rm.hospital_name, rm.investigator_name, rm.mrd_amount, rm.mrd_receipt,rm.accepted) }
}
